import { render, staticRenderFns } from "./oldDashboard.vue?vue&type=template&id=4d3076c8&"
import script from "./oldDashboard.vue?vue&type=script&lang=js&"
export * from "./oldDashboard.vue?vue&type=script&lang=js&"
import style0 from "./oldDashboard.vue?vue&type=style&index=0&id=4d3076c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports